import React from "react";
import withStyles from '@mui/styles/withStyles';
import { useTranslation } from "react-i18next";
import { color } from "common/tokens";

const styles = () => ({
  wrap: {
    position: "sticky",
    top: 0,
    zIndex: 1100,
    width: "100%",
    backgroundColor: color.ACCENT_TINT,
    color: color.ACCENT_TEXT,
    padding: "8px 12px",
    borderBottom: `1px solid ${color.ACCENT}`,
  },
  fullBleed: {
    width: "100vw",
    marginLeft: "calc(50% - 50vw)",
    marginRight: "calc(50% - 50vw)",
  },
  text: {
    margin: 0,
    textAlign: "center",
    fontStyle: "italic",
    fontSize: 14,
    lineHeight: "20px",
    fontWeight: 400,
  },
});

const PreviewBanner = ({ classes, text, fullBleed = true }) => {
  const { t } = useTranslation();
  const label = text || t("previewModeBanner") || "You are in preview mode, progress won’t be saved.";

  return (
    <div
      role="region"
      aria-label="Preview mode notice"
      className={`${classes.wrap} ${fullBleed ? classes.fullBleed : ""}`}
    >
      <p className={classes.text}>{label}</p>
    </div>
  );
};

export default withStyles(styles)(PreviewBanner);
